import { useField } from '@formily/react'

export const TableIndex = () => {
  const field = useField()

  return field.index + 1
}
